import { Formik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  attPreSinAnt,
  attPregestacionalOpt,
  noAplicaOpt,
  noSiOpt,
  opt123,
  primeraVezSubsecuentaOpt,
} from "./constants/options";
import Controller from "./controller/Controller";
import { Fragment, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import Post from "../../../api/Post";
import { MEDICAL_HISTORY_MX } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import Put from "../../../api/Put";
import SimpleLoad from "../../../loader/SimpleLoad";
import Get from "../../../api/Get";

const fields1 = [

  {
    name: "atencionPregestacionalRT",
    type: "select",
    label: "Atención pregestacional",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "relacionTemporalEmbarazo",
    type: "select",
    label: "Consulta embarazo",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "puerpera",
    type: "select",
    label: "Puerpera",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "infeccionPuerperal",
    type: "select",
    label: "Infección puerperal",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "cancerCervicouterino",
    type: "select",
    label: "Consultas por cáncer cervicouteriono",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "cancerMamario",
    type: "select",
    label: "Consulta por cáncer mamario",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "colposcopia",
    type: "select",
    label: "Consulta Colposcopia",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "ultimaFechaColposcopia",
    type: "text",
    label: "Fecha de última Colposcopia",
    options: [],
  },
  {
    name: "descripcionColposcopia",
    type: "text",
    label: "Descripción de última Colposcopia",
    options: [],
  },
  {
    name: "condicionComplicacionPorDiabetes",
    type: "select",
    label: "Complicación por diabetes",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "complicacionPorHemorragia",
    type: "select",
    label: "Complicación por hemorragia",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "complicacionPorInfeccionUrinaria",
    type: "select",
    label: "Complicación por infección urinaria",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "complicacionPorPreeclampsiaEclampsia",
    type: "select",
    label: "Complicación por eclamsia",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "covid19Confirmado",
    type: "select",
    label: "Confirma Covid",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "embarazadaSinDiabetes",
    type: "number",
    label: "Tiras utilizadas para diabetes en embarazadas",
    options: [],
  },
  {
    name: "its",
    type: "select",
    label: "ITS",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "otrasAccApoyoTranslado",
    type: "select",
    label: "Apoyo traslado",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "otrasAccPrescAcidoFolico",
    type: "select",
    label: "Se proporciona ácido fólico",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "patologiaMamariaBenigna",
    type: "select",
    label: "Patología mamaria",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "periPostMenopausia",
    type: "select",
    label: "Consulta Menopausia",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
];

const fields2 = [
  {
    name: "primeraVezAltoRiesgo",
    type: "select",
    label: "Primera vez alto riesgo",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "riesgo",
    type: "select",
    label: "Riesgo gestacional",
    options: [...attPregestacionalOpt, ...attPreSinAnt],
  },
  {
    name: "sospechaCovid19",
    type: "select",
    label: "Sospecha Covid",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "terapiaHormonal",
    type: "select",
    label: "Terapia hormonal",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "trimestreGestacional",
    type: "select",
    label: "Trimestre gestacional",
    options: [...noAplicaOpt, ...opt123],
  },
  { name: "menarca", type: "number", label: "Menarca", options: [] },
  { name: "ritmo", type: "text", label: "Ritmo", options: [] },
  {
    name: "ultimoPeriodo",
    type: "text",
    label: "Fecha último periodo",
    options: [],
  },
  {
    name: "duracionPeriodo",
    type: "number",
    label: "Duración último periodo",
    options: [],
  },
  {
    name: "parejasSexuales",
    type: "number",
    label: "Número de Parejas Sexuales",
    options: [],
  },
  { name: "gesta", type: "number", label: "Número de gesta", options: [] },
  { name: "abortos", type: "number", label: "Número de abortos", min: "0", options: [] },
  { name: "semGestacion", type: "number", label: "Numero de semanas de gestación", options: [] },
  { name: "cesareas", type: "number", label: "Número de cesáreas", options: [] },
  {
    name: "hipertension",
    type: "select",
    label: "¿Padece hipertensión?",
    options: [
      { label: 'Sí', value: 'Sí' },
      { label: 'No', value: 'No' }
    ],
  },
  {
    name: "controlPrenatal",
    type: "select",
    label: "¿Control prenatal?",
    options: [
      { label: 'Sí', value: 'Sí' },
      { label: 'No', value: 'No' }
    ],
  },
  {
    name: "metodoControlPrenatal",
    type: "select",
    label: "Método de control",
    options: [
      { label: 'DIU', value: 'DIU' },
      { label: 'Ritmo', value: 'Ritmo' },
      { label: 'Abstinencia', value: 'Abstinencia' },
      { label: 'Otros', value: 'Otros' },
    ],
  },
  {
    name: "papanicolao",
    type: "select",
    label: "¿Se ha realizado Papanicolao?",
    options: [
      { label: 'Sí', value: 'Sí' },
      { label: 'No', value: 'No' }
    ],
  },
  {
    name: "ultimaFechaPapanicolao",
    type: "text",
    label: "Fecha del último Papanicolao",
    options: [],
  },
  {
    name: "descripcionPapanicolao",
    type: "text",
    label: "Descripción del último Papanicolao",
    options: [],
  },
  {
    name: "mastografia",
    type: "select",
    label: "¿Se ha realizado alguna Mastografía?",
    options: [
      { label: 'Sí', value: 'Sí' },
      { label: 'No', value: 'No' }
    ],
  },
  {
    name: "ultimaFechaMastografia",
    type: "text",
    label: "Fecha de la última Mastografía",
    options: [],
  },
  {
    name: "descripcionMastografia",
    type: "text",
    label: "Descripción de la última Mastografía",
    options: [],
  },
  {
    name: "tipoMenopausia",
    type: "select",
    label: "¿Que tipo de menopausia padece?",
    options: [
      { label: 'Premenopausia', value: 'Premenopausia' },
      { label: 'Postmenopausia', value: 'Postmenopausia' },
      { label: 'No aplica', value: 'No aplica' },
    ],
  },
];

export default function GinecoObstetricoMex({
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  citaId,
  gineco = null,
  validationData,
}) {
  const { auth } = useContext(authContext);
  const [isSubmiting, setSubmiting] = useState(false);
  const schema = Yup.object().shape({
    puerpera: Yup.number().test(
      'puerpera',
      'Valor inválido',
      function (value) {
        const { gender, age } = validationData;
        const { atencionPregestacionalRT, relacionTemporalEmbarazo } = this.parent;
        if (gender == 'Female' && age.years >= 9 && age.years <= 59 && atencionPregestacionalRT == -1 && relacionTemporalEmbarazo == -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    atencionPregestacionalRT: Yup.number()
      .test(
        'atencionPregestacionalRT',
        'Valor inválido',
        function (value) {
          const { gender, age } = validationData;
          const { relacionTemporalEmbarazo, puerpera } = this.parent;
          if (gender == 'Female' && age.years >= 9 && age.years <= 59 && relacionTemporalEmbarazo == -1 && puerpera == -1) {
            return value == 0 || value == 1;
          } else {
            return value == -1;
          }
        }
      ),
    infeccionPuerperal: Yup.number().test(
      'infeccionPuerperal',
      'Valor inválido',
      function (value) {
        const { puerpera } = this.parent;
        if (puerpera != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    relacionTemporalEmbarazo: Yup.number().test(
      'relacionTemporalEmbarazo',
      'Valor inválido',
      function (value) {
        const { gender, age } = validationData;
        const { atencionPregestacionalRT, puerpera } = this.parent;
        if (gender == 'Female' && age.years >= 9 && age.years <= 59 && atencionPregestacionalRT == -1 && puerpera == -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    cancerCervicouterino: Yup.number().test(
      'cancerCervicouterino',
      'Valor inválido',
      function (value) {
        const { speciality, claveTipoEstablecimiento, claveTipologia, claveSubtipologia } = validationData;
        if (![15, 16].includes(speciality) &&
          ((claveTipoEstablecimiento == 2 && ['M', 'N', 'O'].includes(claveTipologia)) ||
            (claveTipoEstablecimiento == 1 && ['T07', 'UNE05', 'UNE07', 'UNE11', 'UNE99'].includes(claveSubtipologia)))) {
          return value == -1 || value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    cancerMamario: Yup.number().test(
      'cancerMamario',
      'Valor inválido',
      function (value) {
        const { speciality, claveTipoEstablecimiento, claveTipologia, claveSubtipologia } = validationData;
        if (![15, 16].includes(speciality) &&
          ((claveTipoEstablecimiento == 2 && ['M', 'N', 'O'].includes(claveTipologia)) ||
            (claveTipoEstablecimiento == 1 && ['T07', 'UNE05', 'UNE07', 'UNE11', 'UNE99'].includes(claveSubtipologia)))) {
          return value == -1 || value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    colposcopia: Yup.number().test(
      'colposcopia',
      'Valor inválido',
      function (value) {
        const { speciality } = validationData;
        if (![15, 16].includes(speciality)) {
          return value == -1 || value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    condicionComplicacionPorDiabetes: Yup.number().test(
      'condicionComplicacionPorDiabetes',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    complicacionPorHemorragia: Yup.number().test(
      'complicacionPorHemorragia',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    complicacionPorInfeccionUrinaria: Yup.number().test(
      'complicacionPorInfeccionUrinaria',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    complicacionPorPreeclampsiaEclampsia: Yup.number().test(
      'complicacionPorPreeclampsiaEclampsia',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    covid19Confirmado: Yup.number().test(
      'covid19Confirmado',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    embarazadaSinDiabetes: Yup.number().test(
      'embarazadaSinDiabetes',
      'Valor inválido',
      function (value) {
        const { gender, age } = validationData;
        if (gender == 'Female' && age.years >= 9 && age.years <= 59) {
          return value >= 1 && value <= 9;
        } else {
          return value == 0;
        }
      }
    ),
    its: Yup.number().test(
      'its',
      'Valor inválido',
      function (value) {
        const { speciality } = validationData;
        if (![15, 16].includes(speciality)) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    otrasAccApoyoTranslado: Yup.number().test(
      'otrasAccApoyoTranslado',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    otrasAccPrescAcidoFolico: Yup.number().test(
      'otrasAccPrescAcidoFolico',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    patologiaMamariaBenigna: Yup.number().test(
      'patologiaMamariaBenigna',
      'Valor inválido',
      function (value) {
        const { speciality, claveTipoEstablecimiento, claveTipologia, claveSubtipologia } = validationData;
        if (![15, 16].includes(speciality) &&
          ((claveTipoEstablecimiento == 2 && ['M', 'N', 'O'].includes(claveTipologia)) ||
            (claveTipoEstablecimiento == 1 && ['T07', 'UNE05', 'UNE07', 'UNE11', 'UNE99'].includes(claveSubtipologia)))) {
          return value == -1 || value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    periPostMenopausia: Yup.number().test(
      'periPostMenopausia',
      'Valor inválido',
      function (value) {
        const { gender, speciality } = validationData;
        if (gender == 'Female' && ![15, 16].includes(speciality)) {
          return value == -1 || value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    primeraVezAltoRiesgo: Yup.number().test(
      'primeraVezAltoRiesgo',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    riesgo: Yup.string().test(
      'riesgo',
      'Valor inválido',
      function (value) {
        const { atencionPregestacionalRT } = this.parent;
        if (atencionPregestacionalRT != -1) {
          const validOptions = ['1', '2', '3', '4', '5', '9'];
          const values = value ? value.split('&') : [];
          return values.every(val => validOptions.includes(val));
        } else {
          return value == 9;
        }
      }
    ),
    sospechaCovid19: Yup.number().test(
      'sospechaCovid19',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    terapiaHormonal: Yup.number().test(
      'terapiaHormonal',
      'Valor inválido',
      function (value) {
        const { gender, speciality } = validationData;
        if (gender == 'Female' && ![15, 16].includes(speciality)) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    trimestreGestacional: Yup.number().test(
      'trimestreGestacional',
      'Valor inválido',
      function (value) {
        const { relacionTemporalEmbarazo } = this.parent;
        if (relacionTemporalEmbarazo != -1) {
          return value == 1 || value == 2 || value == 3;
        } else {
          return value == -1;
        }
      }
    ),
    menarca: Yup.number().required('Campo requerido'),
    ritmo: Yup.string().required('Campo requerido'),
    ultimoPeriodo: Yup.date()
      .nullable()
      .typeError('Ingrese una fecha válida (dd/mm/aaaa)')
      .when('enfermedadRepeticion', {
        is: 'Sí',
        then: Yup.date().required('Requerido').typeError('Ingrese una fecha válida (dd/mm/aaaa)'),
      }),
    duracionPeriodo: Yup.number().required('Campo requerido'),
    parejasSexuales: Yup.number().required('Campo requerido'),
    gesta: Yup.number().required('Campo requerido'),
    abortos: Yup.number().required('Campo requerido'),
    semGestacion: Yup.number().required('Campo requerido'),
    hipertension: Yup.string().test(
      'hipertension',
      'Valor inválido',
      function (value) {
        return value == 'Sí' || value == 'No';
      }
    ),
    controlPrenatal: Yup.string().test(
      'controlPrenatal',
      'Valor inválido',
      function (value) {
        return value == 'Sí' || value == 'No';
      }
    ),
    metodoControlPrenatal: Yup.string()
      .when('controlPrenatal', {
        is: 'Sí',
        then: Yup.string()
          .required('Required')
          .test(
            'metodoControlPrenatal',
            'Valor inválido',
            value => ['DIU', 'Ritmo', 'Abstinencia', 'Otros'].includes(value)
          ),
        otherwise: Yup.string().notRequired()
      }),
      /*ultimaFechaColposcopia: Yup.string()
      .when('colposcopia', {
        is: 'Sí',
        then: Yup.date().required('Requerido').typeError('Ingrese una fecha válida (dd/mm/aaaa)'),
        otherwise: Yup.string().notRequired()
      }),*/
      papanicolao: Yup.string().test(
        'papanicolao',
        'Valor inválido',
        function (value) {
          return value == 'Sí' || value == 'No';
        }
      ),
      mastografia: Yup.string().test(
        'mastografia',
        'Valor inválido',
        function (value) {
          return value == 'Sí' || value == 'No';
        }
      ),
      tipoMenopausia: Yup.string().test(
        'tipoMenopausia',
        'Valor inválido',
        function (value) {
          return value == 'Premenopausia' || value == 'Postmenopausia' || value == 'No aplica';
        }
      ),

  });
  const [initValues, setInitValues] = useState(gineco);

  useEffect(() => {
    if (initValues?.id) {
      setSubmiting(true);
      Get({
        url: `${MEDICAL_HISTORY_MX}/find-obstetric/${initValues.id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setInitValues(response.data);
          setSubmiting(false);
        })
        .catch((error) => {
          console.log(error);
          setSubmiting(false);
        });
    }
  }, [initValues?.id, auth.data.access_token]);

  return (
    <>
      <Formik
        initialValues={
          initValues
            ? initValues
            : {
              appointmentId: citaId,
              atencionPregestacionalRT: "",
              cancerCervicouterino: "",
              cancerMamario: "",
              colposcopia: "",
              condicionComplicacionPorDiabetes: "",
              complicacionPorHemorragia: "",
              complicacionPorInfeccionUrinaria: "",
              complicacionPorPreeclampsiaEclampsia: "",
              covid19Confirmado: "",
              embarazadaSinDiabetes: "0",
              infeccionPuerperal: "",
              its: "",
              otrasAccApoyoTranslado: "",
              otrasAccPrescAcidoFolico: "",
              //otrosRiesgos: "",
              patologiaMamariaBenigna: "",
              periPostMenopausia: "",
              primeraVezAltoRiesgo: "",
              puerpera: "",
              relacionTemporalEmbarazo: "",
              riesgo: "",
              sospechaCovid19: "",
              terapiaHormonal: "",
              trimestreGestacional: "",
              menarca: "0",
              ritmo: "",
              ultimoPeriodo: "",
              duracionPeriodo: "",
              parejasSexuales: "0",
              gesta: "0",
              abortos: "0",
              semGestacion: "", // added
              cesareas: "", // added
              hipertension: "", // added
              controlPrenatal: "", // added
              metodoControlPrenatal: "", // added
              papanicolao: "", // added
              ultimaFechaPapanicolao: "", // added
              descripcionPapanicolao: "", // added
              ultimaFechaColposcopia: "", // added
              descripcionColposcopia: "", // added
              mastografia: "", // added
              ultimaFechaMastografia: "", // added
              descripcionMastografia: "", // added
              tipoMenopausia: "" // added
            }
        }
        validationSchema={schema}
        enableReinitialize
        onSubmit={async (values, { setSubmitting, setFieldValue }) => {
          setSubmiting(true);
          if (values.id) {
            const body = {
              id: values.id,
              ...values,
            };
            try {
              const response = await Put({
                url: `${MEDICAL_HISTORY_MX}/update-obstetric/`,
                data: body,
                access_token: auth.data.access_token,
                header: true,
              });
              setInitValues(response.data);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) { }
          } else {
            try {
              const response = await Post({
                url: `${MEDICAL_HISTORY_MX}/save-obstetric/`,
                data: values,
                access_token: auth.data.access_token,
                header: true,
              });
              setInitValues(response.data);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) {
              setSubmiting(false);
              setShowModalServer(true);
              if (error.response) {
                setErrorServer(error.response);
              }
            }
          }
        }}
      >
        {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            {isSubmiting && <SimpleLoad />}
            <Row>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields1.map((it) => (
                    <Fragment key={it.name}>
                    {
                      ((it.name !== 'descripcionColposcopia' && it.name !== 'ultimaFechaColposcopia') || ( values.colposcopia != -1 && values.colposcopia != '')) ? (
                      <Fragment>
                        <dt className="col-sm-5">{it.label}</dt>
                        <dd className="col-sm-7">
                          <Controller
                            type={it.type}
                            name={it.name}
                            errors={errors}
                            onChange={handleChange}
                            options={it.options}
                          />
                        </dd>
                      </Fragment>
                    ) : null}
                  </Fragment>
                  ))}
                </dl>
              </Col>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields2.map((it) => (
                    <Fragment key={it.name}>
                      {
                        (it.name !== 'metodoControlPrenatal' || values.controlPrenatal == 'Sí') && 
                        ((it.name !== 'descripcionPapanicolao' && it.name !== 'ultimaFechaPapanicolao') || values.papanicolao == 'Sí') &&
                        ((it.name !== 'descripcionMastografia' && it.name !== 'ultimaFechaMastografia') || values.mastografia == 'Sí') ? (
                        <Fragment>
                          <dt className="col-sm-5">{it.label}</dt>
                          <dd className="col-sm-7">
                            <Controller
                              type={it.type}
                              name={it.name}
                              errors={errors}
                              onChange={handleChange}
                              options={it.options}
                            />
                          </dd>
                        </Fragment>
                      ) : null}
                    </Fragment>
                  ))}
                </dl>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-right">
                <Button
                  variant="outline-success"
                  className="ok-buttom"
                  type="submit"
                >
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
}
